import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import VueCryptojs from 'vue-cryptojs'

let app = createApp(App)
app.use(ElementPlus)
app.use(VueCryptojs)
app.mount('#app')
